import { render, staticRenderFns } from "./MultipleTriggerCollapse.vue?vue&type=template&id=373fc3f0"
import script from "./MultipleTriggerCollapse.vue?vue&type=script&lang=js"
export * from "./MultipleTriggerCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports